<template>
<div id="popup-channel">
  <div id="popup-message-window" v-if="showOverlay">
    <a v-if="closable" id="popup-message-close" v-on:click.prevent="closeOverlay">X</a>
    <div v-if="missingUserDataSubform"
         class="data-missing basicForm"
         id="popup-message-content"
         >
      <div v-if="closable" id="close" style="text-align:right;">
        <a style="font-size:x-small;" v-on:click.prevent="closeOverlay">{{ $t('participation.close') }}</a>
      </div>
      <h2 class="popup-message-title">{{ $t('participation.missing_data.title') }}<span  v-if="formMode !== 'OneBigForm'"> {{ missingUserDataCurrentStep }} / {{ missingUserDataSteps.length }}</span></h2>
      <p v-html="$t('participation.missing_data.header', { title: campaignTitle})"></p>
      <PersonForm v-if="showSubForm('person')" :show-errors="showIncompleteFormHint" v-on:user-data-updated="handleUserDataUpdated"/>
      <KidsForm v-if="showSubForm('kids')" :show-errors="showIncompleteFormHint" v-on:user-data-updated="handleUserDataUpdated" />
      <AddressForm
        v-if="showSubForm('address')"
        :show-errors="showIncompleteFormHint"
        v-on:user-data-updated="handlePostalAddressDataUpdated"
        :apiKey="googleApiKey" />
      <TelephoneForm v-if="showSubForm('telephone')" :show-errors="showIncompleteFormHint" v-on:user-data-updated="handleUserDataUpdated" :country-prefix="telPrefix"/>

      <img v-if="axiosBusy" src="static/letsfamily-de/img/spinner.svg"/>

      <div v-if="!allValid && showIncompleteFormHint" class="alert alert-error" role="alert">
        {{ $t('participation.hint_missing_data') }}
        <ul>
          <li v-for="(err, i) in invalidUserDataSteps" :key="i">
            {{$t('form.' + err +'.block_is_incomplete')}}
          </li>
        </ul>
      </div>

      <div v-if="allValid" class="form-submit">
        <button class="btn-primary" v-on:click.prevent="tryParticipation()">
          {{ $t('participation.btn_save_and_continue') }}
        </button>
      </div>
      <div v-else class="form-submit">
        <button class="btn-primary" v-on:click.prevent="showIncompleteFormHint = true">
          {{ $t('participation.btn_validate') }}
        </button>
      </div>
      <small class="text-muted">* {{ $t('form.generic.required') }}</small>
    </div>
    <div v-if="missingCustomFields.length" class="data-missing" id="popup-message-content">
     <CustomFields :missing="missingCustomFields" :campaign="campaignIdent" v-on:data-submitted="tryParticipation"/>
    </div>
    <div v-if="missingTermIdents.length" class="data-missing" id="popup-message-content">
     <Terms :missingTermIdents="missingTermIdents" v-on:terms-agreed="tryParticipation"></Terms>
    </div>
    <div v-if="missingAccessCode.length" class="data-missing" id="popup-message-content">
     <AccessCode :campaign="campaignIdent" :missingAccessCodeSets="missingAccessCode" v-on:access-code-provided="tryParticipation"></AccessCode>
    </div>
    <div v-if="participationError" id="popup-message-content">
      <h2 class="popup-message-title">{{ $t('participation.error.title__' + participationError) }}</h2>
      <h3>{{ $t('participation.error.header') }}</h3>
      <div>{{ $t('participation.error.err__' + participationError) }}</div>
      <div v-if="participationError == 'USER-NOT-ENOUGH-POINTS' || participationError == 'ALREADY-PARTICIPATED'">
        <a class="btn-primary" @click="closeOverlay">{{ $t('participation.error.cta__' + participationError) }}</a>
      </div>
    </div>
    <div v-if="showParticipationResult" id="popup-message-content">
     <ParticipationResult :result="participationResult" :merchantImage="merchantImage" :moreCampaigns="moreCampaigns" v-on:participate-again="tryParticipation"/>
    </div>

    <div v-if="showTelephoneVerify" id="popup-message-content" class="data-missing basicForm" >
      <div v-if="telDialogMode">
        <h2 class="popup-message-title">{{ $t('participation.telephoneVerify.title_request') }}</h2>
        <img v-if="axiosBusy" src="static/letsfamily-de/img/spinner.svg"/>
        <TelephoneVerifyForm :dialogMode="telDialogMode" :hasNonMobile="telNotMobile" v-on:mobile-upd="handleVerification" v-on:mobile-code-sent="handleCodeSent"/>
      </div>
      <div v-if="showTelephoneCode">
        <h2 class="popup-message-title">{{ $t('participation.telephoneVerify.title_confirm') }}</h2>
        <img v-if="axiosBusy" src="static/letsfamily-de/img/spinner.svg"/>
        <div class="form-row">
          <div class="form-item form-item-50" >
            <div class="alert alert-success">
              {{ $t('participation.telephoneVerify.code_sent', { tel: telVerification.tel, created: telVerification.created  }) }}
            </div>
            <label>{{ $t('participation.telephoneVerify.fld_code') }}</label>
            <input
              name="code"
              minlength="5" maxlength="5"
              required
              v-model="telVerifyCode"
              />
            <div class="alert alert-error" v-if="telVerifyCodeInvalid">{{  $t('participation.telephoneVerify.invalid_code') }}</div>
          </div>
        </div>
        <div class="from-row">
          <button :disabled="telVerifyCode.length != 5"
            v-on:click.prevent="sendVerificationCode()"
            class="form-submit btn-primary">{{ $t('participation.telephoneVerify.btn_store_code') }}</button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { bootstrap } from 'vue-gtag'

import PersonForm from '@/components/PersonForm.vue'
import TelephoneForm from '@/components/TelephoneForm.vue'
import KidsForm from '@/components/KidsForm.vue'
import AddressForm from '@/components/AddressForm.vue'
import Terms from '@/components/Terms.vue'
import AccessCode from '@/components/AccessCode.vue'
import ParticipationResult from '@/components/ParticipationResult.vue'
import TelephoneVerifyForm from '@/components/TelephoneVerifyForm.vue'
import CustomFields from '@/components/CustomFields.vue'

import { mapGetters } from "vuex";
import {
  participate, setPoints, verifyTel
} from "@/api/participate.js"

const countryCodes = {
  'de':'+49',
  'at':'+43',
  'ch':'+41',
  'fl':'+423',
};

export default {
  name: 'Participate',
  data: function() {
    return {
      campaignIdent:  this.$parent.campaignIdent,
      campaignTitle: this.$parent.campaignTitle,
      autoParticipate:  this.$parent.autoParticipate,
      merchantImage:  this.$parent.merchantImage,
      moreCampaigns:  this.$parent.moreCampaigns,
      missingUserDataSubform: undefined,
      missingUserDataSteps: [],
      invalidUserDataSteps: [],
      missingUserDataCurrentStep: 0,
      missingTermIdents: [],
      missingAccessCode: [],
      formMode: 'OneBigForm',
      autoSave: true,
      googleApiKey: this.$parent.googleApiKey,
      defaultSaveButton: 'participation.btn_save_and_continue',
      showOverlay: false,
      closable: this.$parent.closable,
      showParticipationResult: false,
      participationResult: {},
      participationError: undefined,
      firstParticipation: false,
      showIncompleteFormHint: false,
      showTelephoneVerify: false,
      telVerification: {},
      telDialogMode: undefined,
      showTelephoneCode: false,
      telVerifyCodeInvalid: false,
      telVerifyCode: "",
      telPrefix: undefined,
      telNotMobile: null,
      missingCustomFields: [],
    }
  },
  async mounted() {
    document.getElementById('popup-channel').addEventListener('startParticipation', () => {
      this.tryParticipation();
    });
    document.getElementById('popup-channel').addEventListener('stopParticipation', () => {
      if (this.closable) {
        this.closeOverlay();
      }
    });
    if ( this.autoParticipate ) {
      await this.tryParticipation();
    }
  },
  methods: {
    showSubForm(form) {
      if (this.formMode == 'OneBigForm') {
        return this.missingUserDataSteps.includes(form) ? true : false;
      }
      else {
        return this.missingUserDataSubform === form ? true : false;
      }
    },
    async handleUserDataUpdated(payload) {
      const idx = this.invalidUserDataSteps.findIndex(sf => sf === payload.subform);
      if (idx !== undefined) {
        this.$delete( this.invalidUserDataSteps, idx);
      }
    },
    async handleVerification() {
      this.showTelephoneVerify = false;
      this.telDialogMode = undefined;
      await this.tryParticipation();
    },
    async handleCodeSent(rv) {
      this.showTelephoneVerify = true;
      this.telVerification = rv.verification;
      this.telDialogMode = undefined;
      this.showTelephoneCode = true;
    },
    async handlePostalAddressDataUpdated(payload) {
      await this.handleUserDataUpdated(payload);
      const country = payload.return.address.country;
      this.telPrefix = countryCodes[country.toLowerCase()];
    },
    async sendVerificationCode() {
      const rv = await verifyTel(this.$userClient, {code: this.telVerifyCode});
      if (rv) {
        if (rv.status == "OK" || rv.error === "NO_TWILIO_CONFIG") {
          this.showTelephoneVerify = false;
          this.telDialogMode = undefined;
          await this.tryParticipation();
        }
        else {
          this.telVerifyCodeInvalid = true;
        }
      }
    },
    async tryParticipation() {
      // turn on overlay and background
      window.scrollTo(0,0);
      document.body.classList.add('formularContent');
      document.getElementById("popup-message-background").classList.add('active');

      let rv;
      try {
        rv = await participate(this.$userClient, this.campaignIdent);
      } catch (e) {
        rv = {};
        this.participationError = "UNKNOWN-ERROR-EMPTY-RESULT";
      }
      this.showOverlay = true;
      this.missingAccessCode = [];
      this.missingTermIdents = [];
      this.missingCustomFields = [];
      this.missingUserDataSubform = undefined;

      if (rv.status === 'error') {
        bootstrap().then(() => {
          this.$gtag.pageview({
            'page_title' : rv.error,
            'page_path': '/f/user-data-form/' + rv.error
          })
        });
        switch (rv.error) {
          case 'REQUIRED-DATA-MISSING': {
            this.closable = false;
            const vm = this;
            const subforms = ['person','kids','address','telephone'];
            let missing = [];
            subforms.forEach(function(form){
              if (rv.missing.find(m => m == form)) {
                if (!vm.missingUserDataSubform) {
                  vm.missingUserDataSubform = form
                }

                if(missing.indexOf(form) === -1) {
                  missing.push(form);
                }
              }
            });
            if (this.missingUserDataSteps.length == 0) {
              this.missingUserDataSteps = missing;
              this.invalidUserDataSteps = missing.slice();
            }
            this.missingUserDataCurrentStep = this.missingUserDataSteps.indexOf(vm.missingUserDataSubform) + 1;
            break;
          }
          case 'CUSTOM-FIELDS-MISSING':
            this.missingCustomFields = rv.missing;
            break
          case 'TERMS-MISSING':
            this.missingTermIdents = rv.missing;
            break;
          case 'ACCESS-CODE-MISSING':
            this.missingAccessCode = rv.missing;
            break;
          // TODO switch through all relevant error cases
          case 'ALREADY-PARTICIPATED':
            if (this.autoParticipate) {
              //window.location = window.location.pathname;
              this.participationError = rv.error;
            }
            else {
              this.participationError = rv.error;
            }
            break;
          case 'MOBILE-TELEPHONE-MISSING':
            this.telNotMobile = true;
            // falls through
          case 'VERIFIED-TELEPHONE-MISSING':
            this.closable = true;
            this.showTelephoneVerify = true;
            this.telDialogMode = rv.error;
            break;
          default:
            this.participationError = "UNKNOWN-ERROR-" + rv.error;
        }
      }
      else if (rv.status == "success") {
        this.showParticipationResult = true;
        this.participationResult = rv;
        await setPoints(this.$frontendClient, rv.current_points);
        bootstrap().then(gtag => {
          if (rv.is_first_participation) {
            gtag.pageview({
              'page_title' : 'User Data Complete',
              'page_path': '/f/user-data-completed'
            });
          }
          gtag.pageview({
            'page_title' : 'Teilgenommen',
            'page_path': '/f/participated'
          });
        });

      }
      else {
        this.participationError = "UNKNOWN-ERROR-EMPTY-RESULT";
      }
    },
    closeOverlay() {
      document.body.classList.remove('formularContent');
      document.getElementById("popup-message-background").classList.remove('active');
      this.showOverlay = false;
      window.location = window.location.pathname;
    }
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy"
    }),
    allValid() {
      return this.invalidUserDataSteps.length == 0 ? true : false;
    }
  },
  components: {
    PersonForm,
    TelephoneForm,
    KidsForm,
    AddressForm,
    Terms,
    AccessCode,
    ParticipationResult,
    TelephoneVerifyForm,
    CustomFields
  },
}
</script>
